(ns dre.components.search-results.views.header
  (:require
   ["antd" :refer [Popover]]
   [clj-commons.humanize :as h]
   [dre.components.dropdown :refer [dropdown dropdown-list]]
   [dre.components.icon :refer [icon fa-icon svg]]
   [dre.components.icons-iconoir :refer [icoinor-icon]]
   [dre.components.inputs :refer [checkbox]]
   [dre.components.tooltip :refer [tooltip-wrapper]]
   [dre.components.search-results.db :as db]
   [dre.components.search-results.events :as-alias results]
   [dre.components.search-results.views.article :refer [tags-selector]]
   [dre.pages.search.events :as-alias search]
   [dre.pages.my-searches.signals.events :as signals-events]
   [dre.pages.my-searches.tags.events :as tag-events]
   [dre.i18n.views :refer [tr]]
   [dre.i18n.events :as-alias i18n]
   [dre.utils.bem :as bem]
   [dre.utils :as utils]
   [reagent.core :as r]
   [re-frame.core :as rf]))


(def component-name :results-header)


(defn select-all
  []
  (let [selected-all? @(rf/subscribe [::results/selected-all?])]
    [checkbox
     {:title (if selected-all?
               @(rf/subscribe [::i18n/translate "Unselect all items"])
               @(rf/subscribe [::i18n/translate "Select all items"]))
      :checked selected-all?
      :on-change #(rf/dispatch [::results/toggle-selected :all])}]))


(defn article-count
  [state]
  (let [is-count? (not (nil? (:total state)))
        total (h/intcomma (:total state))
        selected (count (:selected state))]
    (when is-count?
      (if (pos? selected)
        [:<> "("
         [tr "%s, %s selected" total selected]
         [tooltip-wrapper "Clear selected" [:span
                                            {:on-click #(rf/dispatch [::results/clear-selected])}
                                            [svg :common :dismiss]]]
         ")"]
        (str "(" total ")")))))

(defn apply-tag
  [_user]
  (let [open? (r/atom false)
        close-fn #(reset! open? false)]
    (fn [{:keys [selected] :as state} user]
      (let [show? (seq selected)
            utags (get state :articles-utags)
            all-tags-filtered @(rf/subscribe [::tag-events/tags])]
        (when show?
          [tooltip-wrapper "Tag articles with your own custom label." [:> Popover
                                                                      {:content (r/as-element [tags-selector nil selected utags all-tags-filtered user close-fn])
                                                                       :trigger :click
                                                                       :open @open?
                                                                       :on-open-change (fn [v] (reset! open? v))}
                                                                      [:button
                                                                       {:class (bem/bm :button [:light :medium])}
                                                                       [icon :common :tag]]]])))))

(defn clear-new
  [state]
  (let [signal (:signal @(rf/subscribe [::results/state]))]
    (when (and signal (> (:signal/new-articles signal) 0))
      [tooltip-wrapper "Clear new items" [:button
                                          {:class (bem/bm :button [:light :medium])
                                           :on-click (fn [_]
                                                       (rf/dispatch [::signals-events/mark-visited (:last-seen state) signal])
                                                       (rf/dispatch [::results/fetch nil (:last-seen state)]))}
                                          [fa-icon :eraser]
                                          [tr "Clear new items"]]])))

(defn boost
  []
  (let []
    [tooltip-wrapper "Boost results" [:button
                                      {:class (bem/bm :button [:light :medium])
                                       :on-click #(rf/dispatch [::results/swap-show-boost-searchbar?])}
                                      [fa-icon :arrow-up]]]))


(defn expand-all
  []
  (let [expanded-all? @(rf/subscribe [::results/expanded-all?])]
    [tooltip-wrapper (if expanded-all?
                       "Collapse all abstracts."
                       "Expand all abstracts.")
     [:button
      {:class (bem/bm :button [:light :medium])
       :on-click #(rf/dispatch [::results/toggle-expanded :all])}
      [icon :common (if expanded-all? :collapse :expand)]]]))


(defn ordering
  [{:keys [order]} user]
  (let [selected-order (get (db/order-options-index) (if (contains? (db/order-options-index) order)
                                                       order
                                                       db/default-order))]
    [dropdown
     {:alignment :right

      :anchor
      [:button
       {:class (bem/bm :button [:light :medium])}
       [tr (:label selected-order)]
       [icoinor-icon :nav-arrow-down]]

      :content
      [dropdown-list
       (for [{:keys [id label]} (db/order-options)]
         ^{:key id}
         [:span
          {:style {:cursor :pointer}
           :on-click #(rf/dispatch-sync [::results/replace-in-url id user])}
          [tr label]])]}]))


(defn view
  [state user]
  [:div
   {:class component-name}
   [select-all state]
   [:span
    {:class (bem/be component-name :title)}
    [tr "Results"]]
   [:span
    {:class (bem/be component-name :count)}
    [article-count state]]
   [:span
    {:class (bem/be component-name :actions)}
    [apply-tag state user]
    [clear-new state] 
    (when (utils/dre-user? user)
      [boost state])
    [expand-all state]]
   [:span
    {:class (bem/be component-name :ordering)}
    [ordering state user]]])
